import { render, staticRenderFns } from "./TabLoginImage.vue?vue&type=template&id=60a569f4&"
import script from "./TabLoginImage.vue?vue&type=script&lang=js&"
export * from "./TabLoginImage.vue?vue&type=script&lang=js&"
import style0 from "./TabLoginImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports